import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import PricingGrid from '../components/marketing/PricingGrid';
import { useStudyPlans } from '../hooks/useStudyPlans';
import { formatUsd } from '../data/studyPlans';
import { BRAND } from '../data/siteContent';

export default function PricingPage() {
  const { plans } = useStudyPlans();
  const featured = plans.find((p) => p.featured) || plans[0];

  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <span className="mk-eyebrow">Pricing</span>
          <h1>1, 2, or 3 months of full access.</h1>
          <p>
            {featured
              ? `${featured.name} is ${formatUsd(featured.price)} at ${BRAND.name}.`
              : `Choose the runway that fits your schedule at ${BRAND.name}.`}
          </p>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <PricingGrid />
        </div>
      </section>

      <div className="mk-center-cta" style={{ paddingBottom: 72 }}>
        <Link to="/how-it-works" className="mk-btn mk-btn-secondary">
          See how enrollment works
        </Link>
      </div>
    </MarketingLayout>
  );
}
